import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientService } from './client.service';

export interface UserWorkspaceContextWorkspaceModel {
  id: number;
  name: string;
}

export interface UserWorkspaceContextAccountModel {
  id: number;
  name: string;
  workspaces: UserWorkspaceContextWorkspaceModel[];
}

@Injectable({ providedIn: 'root' })
export class UserWorkspaceContextService {
  private readonly client = inject(ClientService);

  list(): Observable<UserWorkspaceContextAccountModel[]> {
    return this.client.get<UserWorkspaceContextAccountModel[]>(
      'user/workspace-contexts',
    );
  }
}
